export const OSS_PUBLIC_BASE = 'https://zhenzhidiy.oss-cn-hangzhou.aliyuncs.com'
const IMAGE_PREFIX = '/admin/common/image/'

/**
 * 把数据库里的相对路径转成阿里云 OSS 公网地址。
 * 已经是微信头像等外部链接时保持原样。
 */
export function getImageUrl (relativePath) {
  if (!relativePath) return ''
  let url = String(relativePath).trim().replace(/^[`'"]+|[`'"]+$/g, '')
  if (!url) return ''
  if (url.startsWith('data:') || url.startsWith('blob:') || url.startsWith('wxfile://')) {
    return url
  }
  if (url.startsWith('/static/') || url.startsWith('static/')) {
    return url.startsWith('/') ? url : `/${url}`
  }
  if (url.startsWith(OSS_PUBLIC_BASE)) {
    return url
  }
  if (url.startsWith('http://') || url.startsWith('https://')) {
    const marker = IMAGE_PREFIX
    const idx = url.indexOf(marker)
    if (idx < 0) return url
    url = url.substring(idx + marker.length)
  }
  let path = url.replace(/\\/g, '/')
  if (path.startsWith('/')) path = path.substring(1)
  if (path.startsWith('admin/common/image/')) {
    path = path.substring('admin/common/image/'.length)
  }
  if (!path) return ''
  return `${OSS_PUBLIC_BASE}/${path}`
}

/**
 * 把展示用的 OSS 地址还原成数据库保存的相对路径。
 */
export function toStoragePath (url) {
  if (!url) return ''
  const text = String(url).trim()
  if (text.startsWith(`${OSS_PUBLIC_BASE}/`)) {
    return `${IMAGE_PREFIX}${text.substring(OSS_PUBLIC_BASE.length + 1).split('?')[0]}`
  }
  const idx = text.indexOf(IMAGE_PREFIX)
  if (idx >= 0) {
    return text.substring(idx).split('?')[0]
  }
  return text
}
